var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ab-main-hero-animated-background"},[_c(_setup.BackgroundLines,{staticClass:"ab-main-hero-animated-background__lines"}),_vm._v(" "),_c('div',{staticClass:"static-gradient-bg"}),_vm._v(" "),_c('div',{staticClass:"animated-gradient-red"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }